import { regexEmail } from 'mailup-react-helpers'

export const isValidMobileNumber = (s: string): boolean => /^\d{6,20}$/.test(s)

export const isValidMobilePrefix = (s: string): boolean =>
  /^(\+|(00))\d{1,4}$/.test(s)

export const isValidEmail = (s: string): boolean => regexEmail.test(s)
